import CustomList from '../../../core/components/core/Util/List/CustomList/CustomList';
import CustomListContainer from '../../../core/components/core/Util/List/CustomList/CustomListContainer';
import config from '../../config/config';

function List() {

    const pathFrontEnd = '/gci/payment-methods/';
    const endpointBackend = config.endpoints.backend;

    const paths = {
        pathAdd: pathFrontEnd + 'add',
        pathEdit: pathFrontEnd + 'edit',
        pathView: pathFrontEnd + 'view',
        endpointDelete: `${endpointBackend}gci/payment-methods/delete`,
        endpoint: `${endpointBackend}gci/payment-methods/getall`
    }

    let list = {
        labelTitle: 'Lista de Formas de Pagamento',
        labelTitleButtonAdd: 'Incluir nova forma de pagamento',
        fieldsShowOnDelete: ['name'],
        columns: [
            {
                name: 'name',
                label: 'Forma de Pagamento',
            }
        ]
    };

    list = { ...list, ...paths };

    return (
        <div>
            <CustomListContainer
                pathAdd={list.pathAdd}
                labelTitle={list.labelTitle}
                labelTitleButtonAdd={list.labelTitleButtonAdd}
                content={<CustomList list={{ ...list, ...paths }} />}
            />
        </div>
    );
}
export default List;
